import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon8: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 16.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 16" width={width} height={height} {...props}>
      <Path
        d="M9.086 15.993C9.058 15.997 9.029 16 9.001 16C8.971 16 8.942 15.997 8.914 15.993L8.829 15.97L8.78 15.95C8.77 15.945 8.761 15.94 8.752 15.935C8.675 15.891 8.546 15.813 8.366 15.7C8.069 15.513 7.739 15.296 7.384 15.049C6.371 14.345 5.357 13.548 4.409 12.672C1.661 10.131 0 7.45001 0 4.71301C0 2.11001 2.127 0 4.751 0C6.61 0 8.22 1.05899 9.001 2.60199C9.78 1.05899 11.39 0 13.249 0C15.873 0 18 2.11001 18 4.71301C18 7.45001 16.339 10.131 13.591 12.672C12.643 13.548 11.629 14.345 10.616 15.049C10.261 15.296 9.931 15.513 9.634 15.7C9.454 15.813 9.325 15.891 9.253 15.932C9.239 15.94 9.23 15.945 9.22 15.95C9.204 15.957 9.187 15.964 9.171 15.97L9.086 15.993ZM9 5.21301C8.722 5.21301 8.497 4.98901 8.497 4.71301L8.492 4.51599C8.389 2.55799 6.753 1 4.751 1C2.682 1 1.006 2.66301 1.006 4.71301C1.006 7.10801 2.531 9.57 5.094 11.939C6.005 12.781 6.982 13.55 7.96 14.229C8.302 14.467 8.619 14.676 8.904 14.854C8.938 14.876 8.971 14.896 9.001 14.915L9.096 14.854C9.381 14.676 9.698 14.467 10.04 14.229C11.018 13.55 11.995 12.781 12.906 11.939C15.469 9.57 16.994 7.10801 16.994 4.71301C16.994 2.66301 15.318 1 13.249 1C11.18 1 9.503 2.66301 9.503 4.71301C9.503 4.98901 9.278 5.21301 9 5.21301Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
